import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import FiltrosProgramacao from '../components/FiltrosProgramacao';
import { CollapseItemTableIndicator } from "../../comum/components/CollapseItemTableIndicator";
import DetalhesProgramacao from "../components/DetalhesProgramacao";
import LoadingImage from "../../comum/components/LoadingImage";
import Footer from "../../comum/components/Footer";
import Card from "../../comum/components/Card";
import NaviosCard from '../../comum/components/NaviosCard';
import { Row, Container, Button } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

@inject("store")
@observer
export class TabelaProgramacao extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        this.toShow = 20;
        this.controller.listaTabela = [];
        this.controller.itemsTabela = [];
        this.controller.noDataTabela = <LoadingImage />;
        this.controller.turnTabela = 0;
        this.state = {
            // lista: [],
            turn: 0,
            items: [],
            hasMore: false,
            noData: <LoadingImage />,
            linhaExpandida: null,

        };
        window.addEventListener('scroll', HeaderTableFixed);
    }

    componentDidMount() {
        this.setState({ noData: <LoadingImage /> });
        this.controller.setNoDataTabela(<LoadingImage />);
    
        this.controller.carregaFiltros().then(response => {
            this.controller.carregarListaEsperando().then(response => {
                this.controller.listaTabela = this.controller.getLista();
                this.controller.loadFirstTurn();
            });
        });
        
        this.controller.setNoDataTabela(this.controller.tableMessage);
        this.setState({ noData: this.controller.tableMessage });
    }


    alternarSituacaoBerco() {
        this.controller.setItemTabela(false);
        this.controller.setNoDataTabela(<LoadingImage />);
        this.controller.alternarSituacaoBerco();
        this.controller.carregarListaEsperando().then(response => {
            this.controller.listaTabela = this.controller.getLista();
            this.controller.loadFirstTurn();
        });
    }

    clickFiltro() {
        this.setState({ items: [] });
        this.setState({ noData: <LoadingImage /> });
        this.controller.setNoDataTabela(<LoadingImage />);
        this.props.clickBtnFiltro();
    }


    render() {

        const dadosGerais = this.controller.dadosGerais;
        const dadosOperacao = this.controller.dadosOperacao;
        const dadosMov = this.controller.dadosMov;

        const detalhesRow = {
            renderer: (row, rowIndex) => (
                <Row>
                    <DetalhesProgramacao titulo="Dados Gerais" dadosMov={dadosMov} colunas={this.controller.colunas} campos={dadosGerais} row={row} />
                    <DetalhesProgramacao titulo="Datas da Programação" colunas={this.controller.colunas} campos={dadosOperacao} row={row} />
                </Row>
            ),
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                return (
                    <CollapseItemTableIndicator expanded={expanded} />
                );
            }
        };


        return (
            <Container fluid className="tabela-container">

                {this.controller.colunas.length > 10 ?
                    <div><LoadingImage /></div>
                    :

                    <InfiniteScroll
                        dataLength={this.controller.itemsTabela.length}
                        next={() => this.controller.loadNextTurn()}
                        loadder={<span>Carregando....</span>}
                        hasMore={this.controller.hasMoreTabela}
                        loader={<LoadingImage />}
                    >
                        <ToolkitProvider
                            keyField="Viagem"
                            data={this.controller.itemsTabela.slice()}
                            columns={this.controller.colunas.slice()}
                            search
                        >
                            {props => (
                                <div>
                                    <FiltrosProgramacao
                                        controller = {this.props.controller}
                                        clickBtnFiltro={() => this.clickFiltro()}
                                        toggleDataSeletor={() => this.controller.alternarDataSeletor()}
                                        seletorPeriodo={this.controller.seletorPeriodo}
                                        dataInicial={this.controller.dataInicial}
                                        dataFinal={this.controller.dataFinal}
                                        onChangeDataInicio={(valor) => this.controller.setDataInicio(valor)}
                                        onChangeDataFim={(valor) => this.controller.setDataFim(valor)}
                                        filtrarData={(valor) => this.controller.mudarPeriodo(valor)}
                                        situacaoBerco={this.controller.situacaoBerco}
                                        alternarSituacaoBerco={() => this.controller.alternarSituacaoBercoTabela()}
                                    />
                                    <div id="tableHeaderFixed" className={"tabela-prog-navios"}>
                                        {window.innerWidth > 991 ?
                                            <BootstrapTable bootstrap4
                                                striped
                                                bordered={false}
                                                noDataIndication={() => this.controller.noDataTabela}
                                                classes="tabela"
                                                expandRow={detalhesRow}
                                                {...props.baseProps} />
                                            : <Row>
                                                {this.controller.itemsTabela.map((card, x) => (
                                                    <NaviosCard
                                                        controller={this.controller}
                                                        key={x}
                                                        data={card}
                                                        id={x}
                                                        colunas={[...this.controller.colunas]}
                                                        dadosGerais={[...this.controller.dadosGerais]}
                                                        dadosOperacao={[...this.controller.dadosOperacao]}
                                                        titulo={"NavioNome"}
                                                        subtitulo={"Viagem"}

                                                    />
                                                ))}
                                            </Row>
                                        }
                                    </div>
                                </div>)
                            }
                        </ToolkitProvider>


                    </InfiniteScroll>
                }
                <Footer>
                </Footer>
            </Container>

        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/programacao/components/TabelaProgramacao.js